<div class="position-relative h-100">
  @if (variant === 'card') {
    <wl-commodity-offer-card
      [offer]="offer"
      [showLoadingState]="showLoadingState"
    >
      <ed-commodity-offer-header
        [duration]="offer?.durationTitle"
        [productTitle]="offer?.productTitle"
        [productSubTitle]="offer?.productSubtitle"
        [incentive]="offer?.incentiveTitle"
        [highlight]="offer?.isHighlightedLabel"
        [isDynamicProduct]="!!offer?.isDynamicProduct"
        [dynamicPricingTitle]="offer?.dynamicPricingTitle"
        [showPriceTag]="false"
        [enableNewOfferCardTitles]="enableNewOfferCardTitles"
      ></ed-commodity-offer-header>

      <div class="d-flex flex-column flex-grow-1 mt-2">
        <wl-commodity-offer-price-tag
          [offer]="offer"
          [content]="content"
          [termijnbedragVariantA]="termijnbedragVariantA"
          [termijnbedragVariantB]="termijnbedragVariantB"
          class="mb-3"
        ></wl-commodity-offer-price-tag>

        <ng-container *ngTemplateOutlet="offerSharedContent"></ng-container>
      </div>
    </wl-commodity-offer-card>
  }
  @if (variant === 'accordion') {
    <wl-commodity-offer-accordion
      [offer]="offer"
      [opened]="active"
      [showLoadingState]="showLoadingState"
    >
      <ng-template #accordionHeader>
        <ed-commodity-offer-header
          [duration]="offer?.durationTitle"
          [productTitle]="offer?.productTitle"
          [productSubTitle]="offer?.productSubtitle"
          [priceDurationLabel]="content?.priceDurationLabel"
          [priceDurationAlternateLabel]="content?.priceDurationAlternateLabel"
          [withDiscountAlternateLabel]="content?.withDiscountAlternateLabel"
          [price]="offer?.expectedMonthlyAmount"
          [incentive]="offer?.incentiveTitle"
          [highlight]="offer?.isHighlightedLabel"
          [isDynamicProduct]="!!offer?.isDynamicProduct"
          [dynamicPricingTitle]="offer?.dynamicPricingTitle"
          [showPriceTag]="true"
          [enableNewOfferCardTitles]="enableNewOfferCardTitles"
          [termijnbedragVariantA]="termijnbedragVariantA"
          [termijnbedragVariantB]="termijnbedragVariantB"
        ></ed-commodity-offer-header>
      </ng-template>
      <ng-template #accordionBody>
        <div class="d-flex flex-column mt-n3 mx-n2">
          <hr class="mt-0" />
          <wl-commodity-offer-budgetbill-proposal
            [offer]="offer"
            [content]="content"
            class="mb-3"
          ></wl-commodity-offer-budgetbill-proposal>

          <ng-container *ngTemplateOutlet="offerSharedContent"></ng-container>
        </div>
      </ng-template>
    </wl-commodity-offer-accordion>
  }
</div>

<ng-template #offerSharedContent>
  @if (useAlternateCommodityTariffView) {
    <wl-commodity-offer-view-tariffs
      [tariffModalDescriptionLabel]="content?.tariffModalDescriptionLabel"
      [tariffModalLinkTextLabel]="content?.tariffModalLinkTextLabel"
      (viewTariffs)="viewTariffs.emit()"
    ></wl-commodity-offer-view-tariffs>
  }
  @if (!hideCommodityProductBreakdownTable) {
    <ed-commodity-product-breakdown
      [offer]="offer"
      [content]="content"
      [showMemberGetMember]="showMemberGetMember"
    ></ed-commodity-product-breakdown>
  }
  @if (!useAlternateCommodityTariffView) {
    <ed-commodity-vertical-offer-dropdown
      [offer]="offer"
      [content]="content"
      (viewTariffs)="viewTariffs.emit()"
      [expanded]="showTariffs"
      (expand)="openTariffDropdown.emit()"
      (collapse)="closeTariffDropdown.emit()"
      class="mb-2"
    ></ed-commodity-vertical-offer-dropdown>
  }

  <div class="d-flex flex-column">
    @if (content?.costEstimationLabel; as costEstimationLabel) {
      <div
        class="text-center mb-2 line-height-normal"
        *wlGenericRichText="{ value: costEstimationLabel }"
        wlCSCapture
      ></div>
    }

    <crnt-button-alt
      variant="primary"
      (click)="selectOffer.emit()"
      wlAutomationId="offer-submit-button"
      wlCSCapture
    >
      {{ content?.offerSubmitButtonLabel }}
      <crnt-icon slot="trailing" icon="angle-right"></crnt-icon>
    </crnt-button-alt>
    @if (content?.moreInfoPriceAndConditionLinkLabel) {
      <div class="d-flex justify-content-center">
        <crnt-button
          variant="tertiary"
          class="mt-2 mb-1"
          (click)="openMoreInfo.emit()"
          wlAutomationId="info-card-button"
          wlCSCapture
        >
          {{ content?.moreInfoPriceAndConditionLinkLabel }}
        </crnt-button>
      </div>
    }
  </div>
</ng-template>
